import { sendUtagEvent } from '../../core/analytics/utag_events'

export function initializeUtagEvents() {
  document.querySelectorAll('.badges-list .badge.sustainability').forEach(badge => {
    badge.addEventListener('click', function () {
      sendUtagEvent({
        data: {
          event_name: 'sustainability',
          event_cat: 'sustainability',
          event_act: 'tag sustainability',
          event_lbl: '',
          event_purpose: 'inspiration',
          event_structure: 'body',
        },
      })
    })
  })

  document.querySelectorAll('.view-more-sustainability').forEach(link => {
    link.addEventListener('click', function () {
      sendUtagEvent({
        data: {
          event_name: 'sustainability',
          event_cat: 'sustainability',
          event_act: 'view more',
          event_lbl: '',
          event_purpose: 'inspiration',
          event_structure: 'body',
        },
      })
    })
  })
}

export function sendUtagEventSustainability(event_act, event_structure) {
  sendUtagEvent({
    data: {
      event_name: 'sustainability',
      event_cat: 'wave of change module',
      event_act,
      event_lbl: '',
      event_purpose: 'inspiration',
      event_structure,
    },
  })
}
